import { render, staticRenderFns } from "./SearchLinks.vue?vue&type=template&id=511b0004"
import script from "./SearchLinks.vue?vue&type=script&lang=js"
export * from "./SearchLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports